import { API_CORE_HOST, CONFIRMATION_INSTANCE } from "@/helper/consts";
import { sendGetRequest } from "@/helper/requests";

const state = {
  lastCheck: null,
  needAcquaintance: false,
  loading: false
}

const getters = {
  isLoadingAlive: state => state.loading,
  isCheckExpired: state => () => {
    return state.lastCheck
      ? new Date().getTime() - state.lastCheck.getTime() > 15 * 60 * 1000 // 15 минут
      : true
  }
}

const actions = {
  checkConfirmation: ({ commit }) => {
    commit('SET_LOADING')
    const url = `${API_CORE_HOST}${CONFIRMATION_INSTANCE}/user/document/need/acquaintance/`
    return new Promise((resolve, reject) => {
      sendGetRequest(url, (resp) => {
        commit('SET_NEED_ACQUAINTANCE', resp.need_acquaintance)
        commit('SET_CHECK_TIME')
        commit('SET_NOT_LOADING')
        resolve(resp)
      }, (error) => {
        commit('SET_NOT_LOADING')
        reject(error)
      })
    })
  }
}

const mutations = {
  SET_NEED_ACQUAINTANCE: (state, needAcquaintance) => {
    /**
     * Устанавливает флаг необходимости ознакомления
     * @param {Object} state - состояние хранилища
     * @param {boolean} needAcquaintance - нужно ли ознакомление
     */
    state.needAcquaintance = needAcquaintance
  },
  SET_CHECK_TIME: (state) => {
    /**
     * Устанавливает время последней проверки
     * @param {Object} state - состояние хранилища
     */
    state.lastCheck = new Date()
  },
  SET_LOADING: (state) => {
    /**
     * Включает состояние загрузки
     * @param {Object} state - состояние хранилища
     */
    state.loading = true
  },
  SET_NOT_LOADING: (state) => {
    /**
     * Выключает состояние загрузки
     * @param {Object} state - состояние хранилища
     */
    state.loading = false
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
